import { SDKConfiguration } from '../models/config.model'

export function SDKConfigurationMock(options?: Partial<SDKConfiguration>) {
  return {
    apiUrl: options?.apiUrl || 'API_URL',
    client: options?.client || 'WEB',
  }
}
